export default phone => {
  if (String(phone).substr(0, 2) === '07') return `25${phone}`;
  if (String(phone).substr(0, 3) === '250') return `${phone}`;
  if (String(phone).substr(0, 1) === '7') return `250${phone}`;
  return phone;
};
